import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';

// Development build detection
const isDevelopment = process.env.NODE_ENV === 'development';
if (isDevelopment) {
  console.log('Logo Design Brief - Development Build');
}

// Wait for DOM to be ready
document.addEventListener('DOMContentLoaded', () => {
  const rootElement = document.getElementById('root');
  
  if (rootElement) {
    // Add data attribute to indicate development build
    if (isDevelopment) {
      rootElement.setAttribute('data-build-type', 'development');
    }
    
    const root = createRoot(rootElement);
    root.render(
      <StrictMode>
        <App />
      </StrictMode>
    );
  } else {
    console.error('Root element not found');
  }
});